// src/components/LoginQRClone.js - VERSION FINALE CORRIGÉE

import React, { useState, useEffect } from 'react';
import { Html5Qrcode } from 'html5-qrcode';
import cloneManager from '../services/cloneManager';
import AppBrandingMark from './AppBrandingMark';
import './LoginQRClone.css';

export default function LoginQRClone({ onLoginSuccess }) {
  const [step, setStep] = useState('scan'); // 'scan', 'pin', 'manual'
  const [qrData, setQrData] = useState(null);
  const [pin, setPin] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [scanner, setScanner] = useState(null);
  const errorText = typeof error === 'string'
    ? error
    : (error ? JSON.stringify(error) : '');

  // Scanner QR
  const startScanner = async () => {
    try {
      const html5QrCode = new Html5Qrcode("qr-reader");
      setScanner(html5QrCode);

      await html5QrCode.start(
        { facingMode: "environment" },
        { fps: 10, qrbox: 250 },
        async (decodedText) => {
          try {
            console.log('🔵 ========================================');
            console.log('🔵 QR scanné (brut):', decodedText);
            console.log('🔵 ========================================');
            
            const data = JSON.parse(decodedText);
            
            console.log('🔵 Données QR décodées:', data);
            console.log('🔵 ----------------------------------------');
            console.log('🔵 api_url:', data.api_url);
            console.log('🔵 clone_id:', data.clone_id);
            console.log('🔵 clone_name:', data.clone_name);
            console.log('🔵 inspecteur_id:', data.inspecteur_id);
            console.log('🔵 inspector_id:', data.inspector_id);
            console.log('🔵 temp_code:', data.temp_code);
            console.log('🔵 expires_at:', data.expires_at);
            console.log('🔵 TOUS LES CHAMPS:', Object.keys(data));
            console.log('🔵 ========================================');
            
            // ✅ Accepter les 2 orthographes (inspector_id OU inspecteur_id)
            const inspectorId = data.inspecteur_id || data.inspector_id;
            
            // Vérifier que le QR contient les champs nécessaires
            if (!data.api_url || !inspectorId || !data.temp_code) {
              console.error('❌ Champs manquants !');
              console.error('❌ api_url présent:', !!data.api_url);
              console.error('❌ inspector_id présent:', !!inspectorId);
              console.error('❌ temp_code présent:', !!data.temp_code);
              setError('QR code invalide - Format incorrect');
              return;
            }

            // Vérifier l'expiration si présente
            if (data.expires_at && new Date(data.expires_at) < new Date()) {
              console.error('❌ QR expiré:', data.expires_at);
              setError('QR code expiré. Demandez-en un nouveau à votre administrateur.');
              return;
            }

            // ✅ Stocker TEMPORAIREMENT les données QR (pas encore de token)
            setQrData(data);
            console.log('✅ Données QR stockées temporairement');
            
            // Arrêter le scanner
            await html5QrCode.stop();
            setScanner(null);
            
            // Passer à l'étape PIN
            setStep('pin');
            setError('');
          } catch (e) {
            console.error('❌ Erreur décodage QR:', e);
            setError('QR code invalide - ' + e.message);
          }
        },
        (errorMessage) => {
          // Ignorer les erreurs de scan normales
        }
      );
    } catch (err) {
      console.error('❌ Erreur caméra:', err);
      setError('Erreur caméra: ' + err.message);
    }
  };

  // Valider PIN
  const handleValidatePin = async () => {
    if (!pin || pin.length !== 6) {
      setError('Le code PIN doit contenir 6 chiffres');
      return;
    }

    setIsLoading(true);
    setError('');

    try {
      console.log('🔵 ========================================');
      console.log('🔵 VALIDATION PIN');
      console.log('🔵 ========================================');
      console.log('🔵 PIN:', pin);
      console.log('🔵 QR Data:', qrData);
      
      // Générer un device_id unique
      let deviceId = localStorage.getItem('device_id');
      if (!deviceId) {
        deviceId = `device_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
        localStorage.setItem('device_id', deviceId);
        console.log('🔵 Nouveau device_id créé:', deviceId);
      } else {
        console.log('🔵 Device_id existant:', deviceId);
      }

      // ✅ Appeler l'endpoint Rapteck pour validation QR
      const url = `${qrData.api_url}/mobile/auth/validate-qr`;
      console.log('🔵 URL à appeler:', url);
      
      const payload = {
        inspecteur_id: qrData.inspecteur_id || qrData.inspector_id,
        temp_code: qrData.temp_code,
        pin: pin,
        expires_at: qrData.expires_at
      };
      console.log('🔵 Payload:', JSON.stringify(payload, null, 2));
      
      console.log('🔵 Appel fetch...');
      const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      console.log('🔵 Response status:', response.status);
      console.log('🔵 Response ok:', response.ok);
      
      const result = await response.json();
      console.log('🔵 Réponse validateQRAuth:', result);

      if (result.success && result.data && result.data.token) {
        console.log('✅ ========================================');
        console.log('✅ TOKEN REÇU !');
        console.log('✅ ========================================');
        console.log('✅ Token:', result.data.token);
        console.log('✅ Inspecteur:', result.data.inspecteur);
        console.log('✅ Entreprise:', result.data.clone_name);
        
        // ✅ Enregistrer dans cloneManager avec les nouvelles données
        cloneManager.setClone({
          clone_id: result.data.clone_id,
          clone_name: result.data.clone_name,
          api_url: result.data.api_url,
          token: result.data.token,
          inspecteur: result.data.inspecteur,
          logo_url: result.data.logo_url,
          company_name: result.data.company_name
        });

        console.log('✅ Clone enregistré avec succès dans cloneManager');

        // Connexion réussie
        onLoginSuccess({
          clone_id: result.data.clone_id,
          clone_name: result.data.clone_name,
          inspecteur: result.data.inspecteur
        });
      } else {
        console.error('❌ ========================================');
        console.error('❌ ÉCHEC VALIDATION');
        console.error('❌ ========================================');
        console.error('❌ Erreur:', result.message || result.error);
        setError(result.message || 'Code PIN incorrect');
        setIsLoading(false);
      }
    } catch (err) {
      console.error('❌ ========================================');
      console.error('❌ ERREUR CATCH');
      console.error('❌ ========================================');
      console.error('❌ Erreur:', err);
      console.error('❌ Message:', err.message);
      console.error('❌ Stack:', err.stack);
      setError('Erreur de connexion: ' + err.message);
      setIsLoading(false);
    }
  };

  // Connexion manuelle (fallback)
  const [manualToken, setManualToken] = useState('');
  const [manualApiUrl, setManualApiUrl] = useState('');
  const [manualQRData, setManualQRData] = useState('');

  const handleManualLogin = async () => {
    if (!manualToken || !manualApiUrl) {
      setError('Token et URL API requis');
      return;
    }

    setIsLoading(true);
    setError('');

    try {
      console.log('🔵 ========================================');
      console.log('🔵 CONNEXION MANUELLE');
      console.log('🔵 ========================================');
      console.log('🔵 URL API:', manualApiUrl);

      // ✅ Authentifier avec le token
      const response = await fetch(`${manualApiUrl}/functions/authenticateWithToken`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token: manualToken })
      });

      const result = await response.json();
      console.log('🔵 Réponse auth:', result);

      if (result.success && result.inspecteur) {
        console.log('✅ Authentification manuelle réussie');
        
        // ✅ Enregistrer dans cloneManager avec le token
        cloneManager.setClone({
          clone_id: 'manual',
          clone_name: 'Connexion Manuelle',
          api_url: manualApiUrl,
          token: manualToken,
          inspecteur: result.inspecteur
        });

        console.log('✅ Clone manuel enregistré');

        onLoginSuccess({
          clone_id: 'manual',
          clone_name: 'Connexion Manuelle',
          inspecteur: result.inspecteur
        });
      } else {
        console.error('❌ Échec auth manuelle:', result.error);
        setError(result.error || 'Token invalide');
        setIsLoading(false);
      }
    } catch (err) {
      console.error('❌ Erreur connexion manuelle:', err);
      setError('Erreur: ' + err.message);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (step === 'scan') {
      startScanner();
    }
    return () => {
      if (scanner) {
        scanner.stop().catch(console.error);
      }
    };
  }, [step]);

  // UI Loading
  if (isLoading) {
    return (
      <div className="login-container">
        <div className="login-card">
          <div className="logo-container">
            <AppBrandingMark theme="light" />
          </div>
          <h1>Connexion en cours...</h1>
          <div className="loading-spinner">⏳</div>
          <p style={{ color: '#6b7280', marginTop: '16px' }}>
            Validation en cours...
          </p>
        </div>
      </div>
    );
  }

  // UI Scan QR
  if (step === 'scan') {
    return (
      <div className="login-container">
        <div className="login-card">
          <div className="logo-container">
            <AppBrandingMark theme="light" />
          </div>
          <h1>Connexion Inspecteur</h1>
          <p>Scannez le QR code fourni par votre administrateur</p>
          
          <div id="qr-reader" style={{ width: '100%', marginBottom: '20px', borderRadius: '8px', overflow: 'hidden' }}></div>
          
          {errorText && <div className="error-message">{errorText}</div>}
          
          <button 
            onClick={() => setStep('manual')}
            className="secondary-button"
          >
            Connexion manuelle
          </button>

          {process.env.NODE_ENV === 'development' && (
            <button 
              onClick={async () => {
                // MODE TEST : simuler un scan avec des données de test
                try {
                  const testQRData = {
                    api_url: 'http://localhost:3000/api',
                    clone_id: 'test-clone-id',
                    clone_name: 'Rapteck (TEST)',
                    inspecteur_id: 'test-inspecteur-id',
                    temp_code: 'test-temp-code-123',
                    expires_at: new Date(Date.now() + 5 * 60 * 1000).toISOString()
                  };
                  
                  console.log('🧪 MODE TEST - Simulation scan QR:', testQRData);
                  setQrData(testQRData);
                  await scanner?.stop().catch(() => {});
                  setScanner(null);
                  setStep('pin');
                  alert('Mode TEST activé\nPIN de test: 123456\n\nNote: Cette connexion ne fonctionnera pas avec le vrai backend.');
                } catch (err) {
                  console.error('Erreur test:', err);
                }
              }}
              className="secondary-button"
              style={{ backgroundColor: '#f59e0b', color: 'white', marginTop: '10px' }}
            >
              🧪 MODE TEST (Dev)
            </button>
          )}
          
          <div className="info-box">
            💡 Le QR code est unique et personnel. Il vous est fourni par votre administrateur.
          </div>
          
          <div className="footer">Version 1.0.0 • RapteckMobile</div>
        </div>
      </div>
    );
  }

  // UI PIN
  if (step === 'pin') {
    return (
      <div className="login-container">
        <div className="login-card">
          <div className="logo-container">
            <AppBrandingMark
              theme="light"
              previewTenantName={qrData?.company_name || qrData?.clone_name || null}
              previewLogoUrl={qrData?.logo_url || null}
            />
          </div>
          
          <h1>Connexion à</h1>
          <div className="clone-badge">
            {qrData?.clone_name || 'Clone'}
          </div>
          
          <p>Entrez votre code PIN à 6 chiffres</p>
          
          <input
            type="tel"
            inputMode="numeric"
            maxLength="6"
            value={pin}
            onChange={(e) => setPin(e.target.value.replace(/\D/g, ''))}
            placeholder="••••••"
            className="pin-input"
            autoFocus
          />
          
          {errorText && <div className="error-message">{errorText}</div>}
          
          <button 
            onClick={handleValidatePin}
            className="primary-button"
            disabled={pin.length !== 6}
          >
            🔓 Se connecter
          </button>
          
          <button 
            onClick={() => {
              setStep('scan');
              setPin('');
              setQrData(null);
              setError('');
            }}
            className="secondary-button"
          >
            ← Scanner un autre QR code
          </button>
          
          <div className="info-box">
            💡 Votre code PIN vous a été communiqué séparément par votre administrateur.
          </div>
          
          <div className="footer">Version 1.0.0 • RapteckMobile</div>
        </div>
      </div>
    );
  }

  // UI Manual
  return (
    <div className="login-container">
      <div className="login-card">
        <div className="logo-container">
          <AppBrandingMark theme="light" />
        </div>
        <h1>Connexion Manuelle</h1>
        <p>Entrez l'URL de l'API et votre token</p>
        
        <div style={{ marginBottom: '16px' }}>
          <label style={{ fontSize: '13px', color: '#6b7280', display: 'block', marginBottom: '8px', textAlign: 'left', fontWeight: '500' }}>
            URL de l'API
          </label>
          <input
            type="text"
            value={manualApiUrl}
            onChange={(e) => setManualApiUrl(e.target.value)}
            placeholder="https://votre-clone.base44.app"
            className="token-input"
          />
        </div>
        
        <div style={{ marginBottom: '16px' }}>
          <label style={{ fontSize: '13px', color: '#6b7280', display: 'block', marginBottom: '8px', textAlign: 'left', fontWeight: '500' }}>
            Token API
          </label>
          <input
            type="text"
            value={manualToken}
            onChange={(e) => setManualToken(e.target.value)}
            placeholder="rptk_..."
            className="token-input"
          />
        </div>
        
        {errorText && <div className="error-message">{errorText}</div>}
        
        <button 
          onClick={handleManualLogin}
          className="primary-button"
          disabled={!manualToken || !manualApiUrl}
        >
          🔓 Se connecter
        </button>
        
        <button 
          onClick={() => {
            setStep('scan');
            setManualToken('');
            setManualApiUrl('');
            setError('');
          }}
          className="secondary-button"
        >
          ← Retour au scan QR
        </button>
        
        <div className="info-box">
          💡 Contactez votre administrateur pour obtenir votre token d'accès.
        </div>
        
        <div className="footer">Version 1.0.0 • RapteckMobile</div>
      </div>
    </div>
  );
}